interface SummaryDisplayProps {
  summaries: string[];
  title?: string;
}

export function SummaryDisplay({ summaries, title = 'Key Reflections' }: SummaryDisplayProps) {
  if (summaries.length === 0) {
    return null;
  }

  return (
    <div className="accent-bg-lighter border accent-border rounded-xl p-6">
      <h3 className="text-lg font-serif font-semibold accent-text-dark mb-4">
        {title}
      </h3>
      <div className="space-y-3">
        {summaries.map((summary, idx) => (
          <div
            key={idx}
            className="flex items-start gap-3 text-slate-700 dark:text-slate-300"
          >
            <span className="accent-text mt-1 flex-shrink-0">
              •
            </span>
            <p className="leading-relaxed">{summary}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
